import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import {getMobilePanelSize, isMobileWindowWidth} from 'src/utils/responsive';
import {WindowWidthContext} from 'src/components/lib/responsive';


export {WindowWidthContext};

type ResponsiveInfo = {
  windowWidth: number;
  mobilePanelSize: number;
  isMobileWindow: boolean;
};

export const withWindowWidth = <T extends unknown>(
  WrappedComponent: React.ComponentType<T>,
): React.ComponentType<
  Flow_Diff<
    // @ts-expect-error - TS2344 - Type 'T' does not satisfy the constraint '{ windowWidth: any; mobilePanelSize: any; isMobileWindow: any; }'.
    T,
    {
      windowWidth: any;
      mobilePanelSize: any;
      isMobileWindow: any;
    }
  >
> =>
  hoistNonReactStatics(
    (props) => (
      <WindowWidthContext.Consumer>
        {(width) => (
          // @ts-expect-error - TS2769 - No overload matches this call.
          <WrappedComponent
            {...props}
            windowWidth={width}
            mobilePanelSize={getMobilePanelSize(width)}
            isMobileWindow={isMobileWindowWidth(width)}
          />
        )}
      </WindowWidthContext.Consumer>
    ),
    WrappedComponent,
  );

export function useWindowWidth(): ResponsiveInfo {
  const width = React.useContext(WindowWidthContext);
  return {
    windowWidth: width,
    mobilePanelSize: getMobilePanelSize(width),
    isMobileWindow: isMobileWindowWidth(width),
  };
}
